import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { observable, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import DocumentType from "./api-interfaces/documentType.interface";
import { HelperService } from "../helperService";

@Injectable({
    providedIn: 'root'
})
export class APITermsAndPolitics {
    
    ApiURL: string = "";
    
    constructor(private http: HttpClient,public helperService: HelperService) {
        // TODO: create environment variable
        this.ApiURL= environment.termsAndConditionsUrl+'TermsConditionsPolitic'
    }

    public termsAndPoliticsByBrandAndCountryId(brandId,countryId): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        return this.http.get(this.ApiURL+"/"+brandId+"/"+countryId,requestOptions);
    }


 
}

    
